/**
 * Detects if the application is running inside an iframe
 */
export const isInIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    // If we can't access window.top due to cross-origin, we're definitely in an iframe
    return true;
  }
};
